import React from 'react';
import { ModalContent } from '@amzn/atoz-web/Modal';
import { useTranslation } from 'react-i18next';
import { getDropShiftButtons } from './DropShiftButtons';
import { HeaderMessage } from './HeaderMessage';
import { useDropShiftModalContentData } from './utils';
import { useLocation, useNavigate } from '../../../hooks';
import { getRequestTimeOffPath } from '../../../utils';
export var DropShiftModalContent = function (_a) {
    var close = _a.close, dropOpportunity = _a.dropOpportunity, setModalContent = _a.setModalContent, setModalError = _a.setModalError, scheduleShift = _a.scheduleShift;
    var t = useTranslation().t;
    var pathname = useLocation().pathname;
    var navigate = useNavigate();
    var _b = useDropShiftModalContentData({
        dropOpportunity: dropOpportunity,
        setModalContent: setModalContent,
        setModalError: setModalError,
        scheduleShift: scheduleShift
    }), onClickDropNow = _b.onClickDropNow, dropNowIsSubmitting = _b.dropNowIsSubmitting, hasDropPenalty = _b.hasDropPenalty, titleText = _b.titleText, headerMessageType = _b.headerMessageType, dropDeadline = _b.dropDeadline;
    var onClickRequestTimeOff = function () {
        navigate(getRequestTimeOffPath(pathname), {
            external: true
        });
        close();
    };
    return (React.createElement(ModalContent, { dataTestId: "DropShiftModalContent", titleText: titleText, buttons: getDropShiftButtons({
            isDroppable: !!dropOpportunity,
            hasDropPenalty: hasDropPenalty,
            dropNowIsSubmitting: dropNowIsSubmitting,
            onClickDropNow: onClickDropNow,
            onClickRequestTimeOff: onClickRequestTimeOff
        }), onCloseButtonClick: close, closeButtonAltText: t('shift_management_common_closeModalButton') },
        React.createElement(HeaderMessage, { dropDeadline: dropDeadline, type: headerMessageType })));
};
